// Chrome
export const isChrome =
  !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

// Edge detection
export const isEdge = navigator.userAgent.indexOf('Edg') !== -1;

// IE detection
export const isIE = navigator.userAgent.indexOf('MSIE') !== -1;
